import axios from "@/axios";

const BASE_URL = "/bizmsg/alimtalk";

export const alimtalkApi = {
  // 통합 로그/통계 조회
  getLogs(params = {}) {
    return axios.get(`${BASE_URL}/logs`, { params });
  },

  // 로그 + 통계 함께 조회
  getLogsWithStats(params = {}) {
    return axios.get(`${BASE_URL}/logs`, { 
      params: { ...params, includeStats: true } 
    });
  },

  // 통계만 조회
  getStatsOnly(params = {}) {
    return axios.get(`${BASE_URL}/logs`, { 
      params: { ...params, statsOnly: true } 
    });
  },

  // 로그 상세 조회
  getLogDetail(id) {
    return axios.get(`${BASE_URL}/logs/${id}`);
  },

  // 휴대폰 번호로 조회
  getLogsByMobile(mobile, limit = 10) {
    return axios.get(`${BASE_URL}/logs/by-mobile/${mobile}`, { 
      params: { limit } 
    });
  }
};

// 이벤트 타입 옵션
export const EVENT_TYPE_OPTIONS = [
  { label: '전체', value: '' },
  { label: '덴탈맥스', value: 'DENTALMAX' },
  { label: '병원 예약', value: 'RESERVATON_HOSPITAL' },
  { label: '예약 확인', value: 'RESERVATION_CONFIRM' },
  { label: '예약 취소', value: 'RESERVATION_CANCEL' },
  { label: '쿠폰 발급', value: 'COUPON_ISSUE' },
  { label: '이벤트 안내', value: 'EVENT_NOTICE' }
];

// 발송 상태 옵션
export const STATUS_OPTIONS = [
  { label: '전체', value: '' },
  { label: '성공', value: 'SUCCESS' },
  { label: '실패', value: 'FAILED' },
  { label: '오류', value: 'ERROR' }
];

// 상태별 색상 매핑
export const STATUS_COLOR_MAP = {
  SUCCESS: '#52c41a',
  FAILED: '#f5222d',
  ERROR: '#faad14'
};

// 상태별 텍스트 매핑
export const STATUS_TEXT_MAP = {
  SUCCESS: '성공',
  FAILED: '실패',
  ERROR: '오류'
};